import {observe} from '@github-ui/selector-observer'
import poof from '@github-ui/confetti'

observe('.js-confetti-party', () => {
  poof()
})
